import React from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm } from 'react-material-ui-form-validator';

import {
	Grid,
	InputAdornment,
	makeStyles,
	TextField,
	Typography
} from '@material-ui/core';

import PhoneValidator from "./PhoneValidator";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Constants from '../utils/Constants';

const styles = makeStyles(theme => ({
	profileForm: {
		display: "flex",
		alignItems: "left",
		flexDirection: "column",

		"& > div": {
			width: "50%",
			paddingBottom: theme.spacing(3)
		}
	},

	field: {
		"& > label": {
			color: `${theme.palette.text.primary} !important`
		}
	},

	disabled: {
		color: theme.palette.text.primary
	},

	heading: {
		fontWeight: 600
	},

	subHeading: {
		color: Constants.COLORS.SECONDARY.GREY
	}

	// underline: {
	// 	"&::after": {

	// 	}
	// }
}));

function DeliveryProfileSettings(props) {
	let classes = styles(),
		{ user } = props;

	return (
		<ValidatorForm
			id="deliverySettingsWrapper"
			role="group"
			tabIndex={0}
			aria-label="Delivery Settings"
			className={classes.profileForm}
			onSubmit={() => { }}>
			{/* <TextField
				disabled
				id="email"
				name="email"
				label="Email"
				helperText="Your email address"
				value={user.email || ""}
				className={classes.field}
				InputProps={{
					startAdornment: (<InputAdornment position='start'><FontAwesomeIcon icon={["fas", "envelope"]} /></InputAdornment>),
					classes: {
						disabled: classes.disabled,
						// underline: classes.underline
					}
				}} />
			<PhoneValidator
				disabled
				id="cellPhone"
				name="cell_phone"
				label={user.cell_phone && "Mobile Phone" || "Mobile Phone Number Needed"}
				helperText="Your mobile phone number"
				value={user.cell_phone}
				className={classes.field}
				InputProps={{
					startAdornment: (<InputAdornment position='start'><FontAwesomeIcon icon={["fas", "mobile-alt"]} /></InputAdornment>),
					classes: {
						disabled: classes.disabled,
						// underline: classes.underline
					}
				}} />
			<TextField
				disabled
				id="timezone"
				name="timezone"
				label="Timezone"
				helperText="Your timezone"
				value={user.timezone || ""}
				className={classes.field}
				InputProps={{
					startAdornment: (<InputAdornment position='start'><FontAwesomeIcon icon={["fas", "clock"]} /></InputAdornment>),
					classes: {
						disabled: classes.disabled,
						// underline: classes.underline
					}
				}} /> */}
			<Grid container direction="row" alignItems="center" spacing={2}>
				<Grid item>
					<FontAwesomeIcon className={classes.iconHeading} icon={["fas", "envelope"]} />
				</Grid>
				<Grid item>
					<Typography className={classes.heading}>Email</Typography>
					<Typography className={classes.subHeading}>{user.email || ''}</Typography>
				</Grid>
			</Grid>
			<Grid container direction="row" alignItems="center" spacing={2}>
				<Grid item>
					<FontAwesomeIcon className={classes.iconHeading} icon={["fas", "mobile-alt"]} />
				</Grid>
				<Grid item>
					<Typography className={classes.heading}>Phone Number</Typography>
					<Typography className={classes.subHeading}>{user.cell_phone || ''}</Typography>
				</Grid>
			</Grid>
			<Grid container direction="row" alignItems="center" spacing={2}>
				<Grid item>
					<FontAwesomeIcon className={classes.iconHeading} icon={["fal", "clock"]} />
				</Grid>
				<Grid item>
					<Typography className={classes.heading}>Timezone</Typography>
					<Typography className={classes.subHeading}>{user.timezone || ''}</Typography>
				</Grid>
			</Grid>
		</ValidatorForm>
	);
}

DeliveryProfileSettings.propTypes = {
	user: PropTypes.object
};

export default DeliveryProfileSettings;